module.exports = __webpack_public_path__ + "img/bg_function03_3_t.ae315d2c.png";